import type { AnalysisMode, ICFLevel } from '../../types';

export interface AnalysisSummaryState {
    mode: 'coach' | 'engagement';
    analysisMode: AnalysisMode;
    requestedLevel: ICFLevel;
    engagementLevel?: Exclude<ICFLevel, 'auto'>;
    includeMarkerTable: boolean;
    includeInIcfProgress: boolean;
    language: 'tr' | 'en';
}

/** Translation keys (and literal level names) keep this projection pure. */
export function buildAnalysisSummary(state: AnalysisSummaryState) {
    const engagement = state.mode === 'engagement';
    const icf = engagement || state.analysisMode === 'icf';
    const level = engagement ? state.engagementLevel : state.requestedLevel;
    const flag = (value: boolean) => `analysis.simple.${value ? 'included' : 'excluded'}`;
    return {
        title: 'analysis.simple.summaryTitle',
        rows: [
            { key: 'mode', label: 'analysis.modal.modeTitle', value: `analysis.modal.${icf ? 'icfMode' : 'customMode'}` },
            { key: 'level', label: 'analysis.modal.levelTitle', value: !icf ? 'analysis.simple.notApplicable' : level === 'auto' ? 'analysis.simple.levelAuto' : (level?.toUpperCase() || '—') },
            { key: 'msr', label: 'analysis.modal.includeMarkerTable', value: flag(icf && (engagement || state.includeMarkerTable)) },
            { key: 'progress', label: 'analysis.simple.progressLabel', value: flag(!engagement && state.includeInIcfProgress) },
            { key: 'language', label: 'analysis.modal.feedbackLanguage', value: `transcription.modal.${state.language === 'tr' ? 'turkish' : 'english'}` },
        ],
        resultKey: engagement ? 'analysis.simple.engagementResult' : 'analysis.simple.resultToChat',
    };
}
